import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitBtn", "input"]

  connect() {
    // Listen for form submit event (handles both button click and Enter key)
    this.element.addEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    // Check if input has content
    if (this.inputTarget.value.trim() === '') {
      event.preventDefault()
      return
    }

    // Store original placeholder
    this.originalPlaceholder = this.inputTarget.placeholder
    
    // Add submitting state
    this.submitBtnTarget.classList.add('submitting')
    this.submitBtnTarget.disabled = true
    
    // IMPORTANT: Use readonly instead of disabled to prevent user input
    // while still including the field value in form submission.
    // Disabled fields are excluded from form data!
    this.inputTarget.readOnly = true
    this.inputTarget.placeholder = 'Sending...'
    
    // The form will submit normally after this
  }

  submit(event) {
    // This is called when the button is clicked
    // The form submit event will handle the actual submission
  }
}
